module.exports = __webpack_public_path__ + "static/media/17.c883491e.jpg";